import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

import { ClubRedeemRewardRedemptionTemplate } from '../../components/Templates';
import { RewardRedemptionState } from '../../models/RewardStore';
import { useUserStore } from '../../stores/UserStore';
import { useSessionStore } from '../../stores/SessionStore';

const { getCurrentUser } = useUserStore.getState();

const SmartParentsProgramRedemptionScreen = () => {
  const navigate = useNavigate();
  const { id: rewardRedemptionId = '' } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const success = query.get('success') === 'true';

  const isLoggedIn = useSessionStore((state) => state.isLoggedIn);
  useEffect(() => {
    if (!isLoggedIn()) {
      navigate('/start');
    }
  }, [isLoggedIn, navigate]);

  const handleNavigateToGames = useCallback(() => {
    navigate('/club/journey');
  }, [navigate]);

  const handlePressMore = useCallback(() => {
    navigate('/referrals');
  }, [navigate]);

  useEffect(() => {
    getCurrentUser().catch(console.error);
  }, []);

  return (
    <>
      <ClubRedeemRewardRedemptionTemplate
        state={
          success
            ? RewardRedemptionState.Fulfilled
            : RewardRedemptionState.Failed
        }
        onPressMore={success ? handlePressMore : undefined}
        onPressGame={success ? handleNavigateToGames : undefined}
      />
    </>
  );
};

export default SmartParentsProgramRedemptionScreen;
